import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { Box, CircularProgress } from "@mui/material";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import Image from "next/image";
import Coin from "../../../assets/stcoin.png";
import { usePathname, useRouter } from "next/navigation";
import { AddToCartService, Cart } from "@/app/services/cart";
import { FormatedTime } from "../formated-time/FormatedTime";
import { TransitionProps } from "@mui/material/transitions";
import { Loader } from "../MainLoader/Loader";
import "./index.css";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "../card/MaxServiceAlert";
import ShareServices from "../share/ShareService";
import { trackEvent } from "@/app/utils/branch";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const mint = "#1f7a4d";
const mintGradient = "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)";
const mintGradientHover = "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)";

interface ViewDetailsProps {
  id?: any;
  cid?: any;
  open?: any;
  setClose?: any;
  imageUrl?: any;
  heading?: any;
  amount?: any;
  servicedDetails?: any;
  descriptions?: any;
  min?: any;
  subHeading?: any;
  mrp?: any;
  coin?: any;
  addOn?: any;
  handleOpenViewDetailsRsOne?: any;
  sid?: any;
  reloadCartItemsFlag?: any;
  reloadViewDetailsItem?: any;
  setReloadViewDetailsItem?: any;
  aboutList: any;
  serviceCharge: any;
  productCost: any;
  specialPrice: any;
  specialMessage: any;
}

const ViewDetails: React.FC<ViewDetailsProps> = ({
  id,
  cid,
  open,
  setClose,
  imageUrl,
  heading,
  amount,
  servicedDetails,
  descriptions,
  min,
  subHeading,
  mrp,
  coin,
  addOn,
  handleOpenViewDetailsRsOne,
  sid,
  reloadCartItemsFlag,
  reloadViewDetailsItem,
  setReloadViewDetailsItem,
  aboutList,
  serviceCharge,
  productCost,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  const [reloadCartFlag, setReloadCartFlag] = React.useState(false);
  const [zoomStyle, setZoomStyle] = React.useState({});
  const [allCarts, setAllCarts] = React.useState<Cart[] | null>(null);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [openShareDrawer, setOpenShareDrawer] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const router = useRouter();
  const pathName = usePathname();
  const currencyCode = useCurrencyCode();
  const addToCartService = React.useMemo(() => new AddToCartService(), []);

  const handleMouseMove = (e: any) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomStyle({
      transformOrigin: `${x}% ${y}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({});
  };

  const handleCartNavigate = (e: any) => {
    e.preventDefault(e);
    localStorage.setItem("cid", btoa(JSON.stringify(cid)));
    if (pathName !== "/cart") {
      setLoading(true);
      router.push("/cart");
    }
  };

  const handleReferEarnNavigate = (e: any) => {
    trackEvent("REFER_VIEW", id);
    e.preventDefault();
    setOpenShareDrawer(true);
    // if (pathName !== "/refer&earn") {
    //   setLoading(true);
    //   router.push("/refer&earn");
    // }
  };

  const getInitializeCart = React.useCallback(() => {
    const mainCart = addToCartService.getCart();
    if (!mainCart) {
      // console.log("No cart found");
      return;
    }
    const filteredCart = mainCart?.cartItemRequestsById?.filter(
      (item: any) => item.cid == cid
    );
    setAllCarts(filteredCart);
    setReloadCartFlag(false);
  }, [addToCartService, cid]);

  React.useEffect(() => {
    getInitializeCart();
  }, [reloadCartFlag, getInitializeCart, open]);

  React.useEffect(() => {
    if (open) {
      trackEvent("SERVICE_DETAILS", id);
    }
  }, [open, id]);

  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setReloadViewDetailsItem(false);
  }, [
    id,
    reloadViewDetailsItem,
    addToCartService,
    cid,
    setReloadViewDetailsItem,
  ]);

  const handleClose = () => {
    setClose(true);
  };

  const handleClickButton = async () => {
    setIsLoading(true);
    console.log("id of service add into cart " + id);
    if (addOn == true) {
      handleOpenViewDetailsRsOne(sid);
      setReloadCartFlag(true);
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        imageUrl,
        aboutList,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson.count);
        setIsClicked(true);
        reloadCartItemsFlag();
        setReloadCartFlag(true);
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadCartItemsFlag();
        setReloadCartFlag(true);
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      imageUrl,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadCartItemsFlag();
      setReloadCartFlag(true);
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadCartItemsFlag();
      setReloadCartFlag(true);
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      imageUrl,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadCartItemsFlag();
      setReloadCartFlag(true);
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadCartItemsFlag();
      setReloadCartFlag(true);
      setIsLoading(false);
    }
  };

  const dialogStyles = {
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    maxWidth: "750px",
    "::webkitScrollbar": {
      display: "none",
    },
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <Dialog
        fullScreen
        // sx={{
        //   zIndex: 10000,
        // }}
        PaperProps={{
          sx: {
            ...dialogStyles,
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            position: { xs: "absolute", sm: "relative" },
            bottom: 0,
            maxHeight: { xs: "92%", sm: "100%" },
            borderRadius: { xs: "1rem 1rem 0px 0px", sm: "0px" },
            border: { xs: "1px solid rgba(18, 53, 36, 0.1)", sm: "none" },
            boxShadow: { xs: "0 -8px 40px rgba(18, 53, 36, 0.12)", sm: "none" },
          },
        }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        className="scroll-bar"
        closeAfterTransition={false}
      >
        <Box
          sx={{
            position: "relative",
            display: "inline-block",
            // padding: "1rem",
            height: { xs: "40%", sm: "55%" },
          }}
        >
          <KeyboardBackspaceIcon
            sx={{
              background: "#fff",
              borderRadius: "1rem",
              padding: "4px",
              fontSize: "28px",
              position: "absolute",
              top: { xs: "15%", sm: "11%" },
              left: "32px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#000",
              boxShadow: "2px 1px 4px 1px rgba(0, 0, 0, 0.1)",
              zIndex: 100,
              display: { xs: "none", sm: "block" },
            }}
            onClick={handleClose}
          />
          <CloseIcon
            sx={{
              background: "#fff",
              borderRadius: "1rem",
              padding: "5px",
              fontSize: "32px",
              position: "fixed",
              top: "4.5%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              cursor: "pointer",
              color: "#000",
              boxShadow: "2px 1px 4px 1px rgba(0, 0, 0, 0.1)",
              zIndex: 100,
              display: { xs: "block", sm: "none" },
            }}
            onClick={handleClose}
          />
          <Box
            sx={{
              overflow: "hidden",
              height: "100%",
              // borderRadius: { xs: "1rem 1rem 0px 0px", sm: "0px" },
            }}
          >
            <Image
              src={imageUrl}
              priority={true}
              quality={100}
              alt={`Banner ${heading}`}
              height={2000}
              width={2000}
              style={zoomStyle}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
              className="view-details-image"
            />
          </Box>
          <Button
            variant="contained"
            onClick={handleReferEarnNavigate}
            sx={{
              boxShadow: "0 8px 24px rgba(18, 53, 36, 0.25)",
              textTransform: "capitalize",
              borderRadius: "999px",
              padding: "4px 14px",
              position: "absolute",
              top: { xs: "85%", sm: "90%" },
              right: "25px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "white",
              background: mintGradient,
              "&:hover": { background: mintGradientHover },
            }}
          >
            <ShareIcon sx={{ paddingRight: "5px", fontSize: "20px" }} />
            Share & Earn
          </Button>
        </Box>
        <Box sx={{ padding: "1.2rem" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0px 0px 16px 0px",
            }}
          >
            <Box>
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", textTransform: "capitalize" }}
              >
                {heading}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {subHeading}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: "bold", color: "#000" }}
              >
                {currencyCode}
                {amount?.toLocaleString()}/-
              </Typography>
              &nbsp; &nbsp;
              <Typography
                variant="body1"
                sx={{
                  color: "gray",
                  textDecoration: "line-through",
                }}
              >
                {currencyCode}
                {mrp?.toLocaleString()}/-
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "1rem 0px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "999px",
                background: mintGradient,
                color: "white",
                padding: "5px 16px",
                height: "35px",
              }}
            >
              <WatchLaterIcon />
              <Typography variant="body2" sx={{ paddingLeft: "8px" }}>
                <FormatedTime min={min} />
              </Typography>
            </Box>
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "125px",
                  background: "none",
                  borderRadius: "999px",
                  border: `1px solid ${mint}`,
                  height: "35px",
                }}
              >
                <CircularProgress size="25px" sx={{ color: mint }} />
              </Box>
            ) : isClicked ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  background: mintGradient,
                  borderRadius: "999px",
                  height: "35px",
                  color: "white",
                  width: "125px",
                }}
              >
                <RemoveIcon
                  onClick={handleValueDecrease}
                  sx={{ cursor: "pointer" }}
                />
                <Typography>{value}</Typography>
                <AddIcon
                  onClick={handleValueIncrease}
                  sx={{ cursor: "pointer" }}
                />
              </Box>
            ) : (
              <Button
                variant="contained"
                sx={{
                  boxShadow: "0 8px 20px rgba(18, 53, 36, 0.2)",
                  textTransform: "capitalize",
                  minWidth: "10px",
                  background: mintGradient,
                  borderRadius: "999px",
                  height: "35px",
                  width: "125px",
                  "&:hover": { background: mintGradientHover },
                }}
                onClick={handleClickButton}
              >
                Add To Cart
              </Button>
            )}
          </Box>
          <Divider />
          <Box sx={{ margin: "1rem 0px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Image
                className="cart-coin-animation"
                src={Coin}
                height={500}
                width={500}
                alt="coin"
                style={{
                  width: "2rem",
                  height: "2rem",
                }}
              />
              &nbsp; &nbsp;
              <Typography variant="body1" sx={{ fontWeight: "600" }}>
                {coin ? coin : 0} Coin Cashback
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "1rem",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "4px",
                  textTransform: "capitalize",
                }}
              >
                Service Details
              </Typography>
              {servicedDetails &&
                servicedDetails.map((item: any, index: number) => (
                  <Box sx={{ display: "flex", padding: "4px 0px" }} key={index}>
                    <CheckIcon
                      sx={{
                        color: mint,
                        marginRight: "8px",
                        fontSize: "16px",
                      }}
                    />
                    <Typography variant="body2">
                      <Box component="span" sx={{ fontWeight: "bold" }}>
                        {item.split("-")[0]} -
                      </Box>
                      {item.split("-").slice(1).join("-")}
                    </Typography>
                  </Box>
                ))}
            </Box>
            <br />
            <Box>
              {descriptions?.map((item: any, index: any) => (
                <Accordion
                  key={index}
                  sx={{
                    marginBottom: "0px",
                    boxShadow: "none",
                    background: "#fff",
                  }}
                >
                  {/* Title with Expand Icon */}
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: mint }} />}
                    sx={{ padding: "0px" }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      sx={{ textTransform: "capitalize" }}
                    >
                      {item.title.toLowerCase()}
                    </Typography>
                  </AccordionSummary>

                  {/* Points List */}
                  <AccordionDetails sx={{ padding: "8px 0px" }}>
                    {item.points.map((point: string, idx: number) => (
                      <Box
                        key={idx}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: "4px 0px",
                        }}
                      >
                        <CheckIcon
                          sx={{
                            color: mint,
                            marginRight: "8px",
                            fontSize: "16px",
                          }}
                        />
                        <Typography variant="body2">{point}</Typography>
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            width: "-webkit-fill-available",
          }}
        >
          <Button
            variant="contained"
            sx={{
              margin: "8px",
              width: "-webkit-fill-available",
              borderRadius: "999px",
              background: mintGradient,
              padding: "10px 16px",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "1rem",
              boxShadow: "0 8px 24px rgba(18, 53, 36, 0.25)",
              "&:hover": { background: mintGradientHover },
            }}
            disabled={
              allCarts?.length == 0 || allCarts == null || undefined
                ? true
                : false
            }
            onClick={handleCartNavigate}
          >
            CHECKOUT
          </Button>
        </Box>
      </Dialog>
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
      <ShareServices
        drawerOpen={openShareDrawer}
        closeDrawer={() => setOpenShareDrawer(false)}
      />
    </React.Fragment>
  );
};

export default ViewDetails;
